import { ICAService } from '../contracts/ca.api.contracts';
import { caServiceHttp } from './caService.http';

export const caService: ICAService = caServiceHttp;
